<body>
  <div class="grid-overlay">
    <div class="header">
      <div class="logo">
        <a routerLink="/my-portals">
          <img src="../../assets/images/BRAND2.png" alt="logo de Billcentrix">
        </a>
      </div>
      <div class="buttons">
        <img src="../../assets/icons/reportes_aqua.png" alt="icono reportes">
        <app-menu></app-menu>
      </div>
    </div>

    <main class="reports-data">
      <section class="message-panel">
        <h1>Acceso restringido</h1>
        <p>No tienes permisos para acceder a esta sección.</p>
        <span>Selecciona una opción disponible desde el menú.</span>
      </section>
    </main>
  </div>
</body>
